import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Text, IconButton, Flex, Button } from "@chakra-ui/react";
import { memo, useMemo } from "react";
import { isEmpty } from "lodash";
import Slider from "react-slick";

import { History, Suggestion } from "utils/types";

import FadeIn from "./FadeIn";
import Loading from "./Loading";

type HistoriesProps = {
  histories: History[];
  itemsPerPage: number;
  isLoading: boolean;
  keyword: string;
  currentPage: number;
  onSubmit: (value: Suggestion) => void;
  onClear: () => void;
  onSetCurentPage: (value: number) => void;
};

function PrevArrow(props: any) {
  const { className, onClick } = props;

  return (
    <div className={className}>
      <IconButton
        variant="ghost"
        onClick={onClick}
        aria-label="next page"
        size="lg"
      >
        <ChevronLeftIcon color="primary" />
      </IconButton>
    </div>
  );
}
function NextArrow(props: any) {
  const { className, onClick } = props;

  return (
    <div className={className}>
      <IconButton
        variant="ghost"
        onClick={onClick}
        aria-label="next page"
        size="lg"
      >
        <ChevronRightIcon color="primary" />
      </IconButton>
    </div>
  );
}

const Histories = ({
  histories,
  isLoading,
  keyword,
  onSubmit,
  onClear,
}: HistoriesProps) => {
  const settings = useMemo(
    () => ({
      dots: false,
      infinite: false,
      speed: 500,
      swipeToSlide: true,
      variableWidth: true,
      slidesToScroll: Math.min(4, histories.length),
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
    }),
    [histories.length]
  );

  if (isLoading) return <Loading />;

  if (isEmpty(histories)) return <></>;

  return (
    <Flex
      alignItems={{ base: "flex-start", md: "flex-start" }}
      mt="1rem"
      flexDir="column"
    >
      <Flex alignItems="center" justifyContent="space-between" width="100%">
        <Text color="grayTitle">Your history</Text>
        <Button
          ml="1rem"
          variant="ghost"
          colorScheme="red"
          size="xs"
          onClick={onClear}
        >
          Clear
        </Button>
      </Flex>
      <Flex alignItems="center" flexWrap="wrap" alignSelf="center">
        <Flex
          alignItems="center"
          flexWrap="nowrap"
          alignSelf="center"
          paddingBottom="0.5rem"
        >
          <Slider {...settings}>
            {histories.map((item) => (
              <FadeIn key={item.id}>
                <Flex
                  alignItems="center"
                  px={{ base: "0.5rem", md: "1rem" }}
                  justifyContent="center"
                >
                  <Box
                    fontSize="sm"
                    as="a"
                    color="gray"
                    onClick={() =>
                      onSubmit({ word: item.query_keyword, pos: "" })
                    }
                    cursor="pointer"
                  >
                    <Text
                      fontWeight={
                        item.query_keyword === keyword ? "bold" : "normal"
                      }
                    >
                      {item.query_keyword}
                    </Text>
                  </Box>
                </Flex>
              </FadeIn>
            ))}
          </Slider>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default memo(Histories);
